export const Z_MIN = -4;
export const Z_MAX = 4;

export const ANIMATION_DURATION = 500; // milliseconds
export const SAMPLE_COUNT = 64;
export const DECIMAL_PRECISION = 2;

export const CSV_FILENAME = "sexdifference.csv";

export const HATCH = false;

export const GROUP_NAMES = {
	a: "Male",
	b: "Female",
};
